module.exports = __webpack_public_path__ + "img/Reg-8-Exhibition.8b01ff7c.svg";